// src/pages/healthcare/consultation/consultationComponents/ConsultTranscriptDrawer.tsx
import React from "react";
import { Badge, Drawer, Space } from "antd";
import { CommentOutlined } from "@ant-design/icons";

import TranscriptList, { TranscriptListProps } from "./Transcript";

interface ConsultTranscriptDrawerProps {
	open: boolean;
	onClose: () => void;
	count: number;
	transcript: TranscriptListProps;
}

const ConsultTranscriptDrawer: React.FC<ConsultTranscriptDrawerProps> = ({ open, onClose, count, transcript }) => {
	return (
		<Drawer
			title={
				<Space>
					<CommentOutlined />
					<span>Consultation Transcript</span>
					<Badge count={count} size="small" />
				</Space>
			}
			placement="right"
			open={open}
			onClose={onClose}
			width={450}
			styles={{ body: { padding: 8 }, header: { padding: "8px 16px", borderBottom: "1px solid var(--border-color)" } }}
			zIndex={1001}
		>
			<TranscriptList {...transcript} />
		</Drawer>
	);
};

export default ConsultTranscriptDrawer;
